"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const highcharts_1 = __importDefault(require("highcharts"));
const highcharts_react_official_1 = __importDefault(require("highcharts-react-official"));
const i18n_1 = __importDefault(require("src/locales/settings/i18n"));
const ChartPie_module_css_1 = __importDefault(require("./styles/ChartPie.module.css"));
const localConstants_1 = require("src/stores/applicationStore/stat/localConstants");
const EmptyBlock_1 = __importDefault(require("src/components/molecules/EmptyBlock"));
const ChartPie = ({ title, underTitle, name, data }) => {
    const chartRef = (0, react_1.useRef)(null);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("h3", { children: title }), !!underTitle && (0, jsx_runtime_1.jsx)("div", Object.assign({ className: ChartPie_module_css_1.default.underTitle }, { children: underTitle })), (0, jsx_runtime_1.jsx)("div", { children: data && data.length > 0 ? ((0, jsx_runtime_1.jsx)(highcharts_react_official_1.default, { ref: chartRef, highcharts: highcharts_1.default, options: Object.assign(Object.assign({}, localConstants_1.chartPieOptions), { series: [
                            {
                                type: "pie",
                                name: name,
                                colorByPoint: true,
                                data: data,
                                dataLabels: [
                                    { enabled: false },
                                    {
                                        enabled: true,
                                        distance: -40,
                                        format: "{point.percentage:.1f}%",
                                        style: {
                                            fontSize: "1.2em",
                                            textOutline: "none",
                                            opacity: 0.7,
                                        },
                                        filter: {
                                            operator: ">",
                                            property: "percentage",
                                            value: 10,
                                        },
                                    },
                                ],
                            },
                        ] }) })) : data ? ((0, jsx_runtime_1.jsx)(EmptyBlock_1.default, { title: i18n_1.default.t("No data") })) : ((0, jsx_runtime_1.jsx)(EmptyBlock_1.default, { title: i18n_1.default.t("Loading") })) })] }));
};
exports.default = ChartPie;
